import React, { Component, useMemo } from 'react'
import { bindActionCreators } from '@reduxjs/toolkit'
import { connect } from 'react-redux'
import methods from '../reducers/methods'
import * as ConfigActions from '../reducers/config'
import * as UserActions from '../reducers/user'
import * as BotProfileActions from '../reducers/botProfile'
import Modal from '@mui/material/Modal'
import CustomTheme from '../components/CustomTheme'
import {
    BrowserRouter as Router,
    Route,
    Link,
    Switch
} from "react-router-dom"
import { withRouter } from "react-router"
import SwipeableViews from 'react-swipeable-views'
import { IonRouterOutlet, IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import {
    Grid,
    Paper,
    Typography,
    Drawer,
    Toolbar,
    Divider,
    Box,
    Stack,
    CssBaseline,
    List,
    ListItem
} from '@mui/material'
import AppNavigator from '../components/AppNavigator'
import * as Buttons from '../components/UIComponents/Button'
import * as Images from '../components/UIComponents/Images'
import * as Texts from '../components/UIComponents/Text'
import SwitchButtons from './Onboarding/SelectBot'
import NurseOnboarding from './Onboarding/NurseOnboarding'
import FAQBotOnboarding from './Onboarding/FAQBotOnboarding'
import BotHelper from '../helpers/BotHelper'
import UserProfileHelper from '../helpers/UserProfileHelper'; // Import UserProfileHelper
import AuthenticationHelper from '../helpers/AuthenticationHelper'
import TypingAnimation from '../components/UIComponents/TypingAnimation'
import { v4 as uuidv4 } from 'uuid'
import { defaultLang } from '../lang/init'

const { innerWidth, innerHeight } = window

class Onboarding extends Component {
    state = {
        index: 0,
        modalOpen: false,
        userId: "",
        password: "",
        botProfiles: []//added to test bot profiles, please remove after it is working
    };


    async componentDidMount() {
        // console.log(this.props)
        const { config, user, login, switchLanguage, resetSession } = this.props
        const { dict, lang } = config
        // clean the previous session and create a new one
        resetSession()

        // better the load the language every time logging into the app
        switchLanguage(defaultLang)

        ////////////////////////////////////////
        //test functions for the bot profile  //
        ///////////////////////////////////////
        // Load all bot profiles
        //await this.loadAllBotProfiles()

        //test add bot
        //await this.addTestBotProfile();

        //test update bot
        //await this.updateTestBotProfile("8bd90de1-db1b-4f15-8a0b-76f2ef90009b");

        ////////////////////////////////////////
        //test functions for the user profile  //
        ///////////////////////////////////////

        // Load all user profiles for testing
        // let results = await AuthenticationHelper.login("test","test");
        // await this.loadAllUserProfiles(AuthenticationHelper.uuid);

        // Test add user profile
        //await this.addTestUserProfile();

        // Test update user profile
        //await this.updateTestUserProfile(AuthenticationHelper.uuid);

        // Test fetching bots by user ID
        //await this.getBotsByUserId(AuthenticationHelper.uuid);

    }
    ///////////////////////////////////
    //test bot profile functions     //
    ///////////////////////////////////
    // Function to load all bot profiles from the backend
    loadAllBotProfiles = async () => {
        const botProfiles = await BotHelper.getAllBotProfileIds();
        // console.log("bot profiles", botProfiles)

        if (botProfiles && botProfiles.data) {
            const detailedProfiles = await Promise.all(botProfiles.data.map(async (id) => {
                return await BotHelper.getBotProfileById(id);
            }));
            this.setState({ botProfiles: detailedProfiles });
            // console.log(this.state.botProfiles)
        }
    }

    // Function to add a test bot profile
    addTestBotProfile = async () => {
        const testProfile = {
            name: "TestBot2",
            age: 30,
            gender: "Non-binary",
            story: "Test story.",
            background: "Test background.",
            personality: "Test personality.",
            symptomsAndBehaviours: "Test symptoms and behaviours.",
            responseStyle: "Test response style.",
            shortMem: "Short-term memory.",
            longMem: "Long-term memory."
        };
        const response = await BotHelper.addBotProfile(testProfile);
        if (response.status === 'success') {
            await this.loadAllBotProfiles();  // Reload profiles after adding
        }
    }

    // Function to update a bot profile
    updateTestBotProfile = async (id) => {
        const updateData = { name: "UpdatedTestBot V3" };
        const response = await BotHelper.updateBotProfile(id, updateData);
        if (response.status === 'success') {
            await this.loadAllBotProfiles();  // Reload profiles after updating
        }
    }


    ///////////////////////////////////
    //end test bot profile functions  //
    ///////////////////////////////////

    ///////////////////////////////////
    // Test functions for user profile
    ///////////////////////////////////

    // Function to load all user profiles from the backend
    loadAllUserProfiles = async (id) => {
        const userProfiles = await UserProfileHelper.getAllUserProfileIds();
        console.log("user profiles", userProfiles);

        const currentProfile =await UserProfileHelper.getUserProfileById(id);
        console.log(currentProfile);
    }

    // Function to get a single user profile and their bots
    getUserProfileAndBots = async (userId) => {
        const { login, history } = this.props
        const questionSessionId = uuidv4()

        const userProfile = await UserProfileHelper.getUserProfileById(userId);
        console.log("User Profile:", userProfile);
        // add user profile to the reducer
        let toSaveReducerUser = {
            id: AuthenticationHelper.uuid,
            sessionId: questionSessionId,
            age: userProfile.hasOwnProperty("age") ? userProfile.age : undefined,
            gender: userProfile.hasOwnProperty("gender") && (userProfile.gender === "Male" || userProfile.gender === "Female") ? userProfile.gender : undefined,
            demographic: userProfile.hasOwnProperty("demographic") && typeof userProfile.demographic === "string" ? userProfile.demographic : undefined,
            bots_owned: userProfile.hasOwnProperty("bots_owned") && Array.isArray(userProfile.bots_owned) ? userProfile.bots_owned : undefined,
            recent_activities: userProfile.hasOwnProperty("recent_activities") && typeof userProfile.recent_activities === "string" ? userProfile.recent_activities : undefined,
            username: userProfile.hasOwnProperty("username") && typeof userProfile.username === "string" ? userProfile.username : undefined,
        }
        await login(toSaveReducerUser)
        // temporarily remove. I don't think there needs to be another query.
        // const userBots = await UserProfileHelper.getUserBots(userId);
        // console.log("User Bots:", userBots);
        return userProfile
    }

    // Function to add a test user profile
    // addTestUserProfile = async () => {
    //     const testProfile = {
    //         username: "TestUser",
    //         bots_owned: [], // Add bot IDs here if available
    //         age: 25,
    //         gender: "Non-binary",
    //         demographic: "Test demographic",
    //         background: "Test background",
    //         recent_activities: "Test recent activities"
    //     };
    //     const response = await UserProfileHelper.addUserProfile(testProfile);
    //     if (response && response.status === 'success') {
    //         await this.loadAllUserProfiles(); // Reload profiles after adding
    //     }
    // }

    // Function to update a user profile
    // updateTestUserProfile = async (userId) => {
    //     const updateData = { username: "UpdatedTestUserV2" };
    //     const response = await UserProfileHelper.updateUserProfile(userId, updateData);
    //     if (response && response.status === 'success') {
    //         await this.loadAllUserProfiles(); // Reload profiles after updating
    //     }
    // }

    // Function to get bot IDs by user ID
    getBotsByUserId = async (userId) => {
        const botIds = await UserProfileHelper.getUserBots(userId);
        // console.log(`Bot IDs for user ${userId}:`, botIds);
        return botIds;
    }

    ///////////////////////////////////
    // End test user profile functions
    ///////////////////////////////////

    handelModalOpenClose = (open = false) => {
        this.setState({
            modalOpen: open
        })
    }

    handleUserLogin = async (userId, password) => {
        // console.log(this.props)
        const { login, history, user, loadProfile } = this.props
        // console.log(`login using ${userId} and ${password}`)
        const authResult = await AuthenticationHelper.login(userId, password)
        // console.log("auth result", authResult)
        if(!authResult)
        {
            // TODO: do error control
            alert("ユーザーIDを確認してください")
            return
        }
        // findout how many chatbot this user has and pull the user's profile
        const userProfile = await this.getUserProfileAndBots(AuthenticationHelper.uuid)
        // console.log("user profile and bots", user)
        const allBots = userProfile?.bots_owned
        // const allBots = await this.getBotsByUserId(AuthenticationHelper.uuid)
        // console.log("no of bots", allBots)

        if(Array.isArray(allBots))
        {
            if(allBots.length <= 0)
            {
                // user does not have any associated chatbot, need to set up the chatbot profile first
                history.push("/profilesetup/user-profile")
            }
            else
            {
                if(userProfile?.recent_activities !== "BOT_CREATING_IN_PROGRESS")
                {
                    // user can be redirected to the main bot
                    history.push("/chatroom/pdfbot")
                }
                else
                {

                    // user is in the progress of creating a chatbot. Fill the data using the bots_owned data
                    const targetBot = allBots[0]
                    // get the chatbot profile and load it into redux storage. In case user wants to edit the profile
                    let targetBotProfile = await BotHelper.getBotProfileById(targetBot)
                    console.log("user has bot, but is in the progress of creating the profile", targetBotProfile["data"])
                    let formattedTargetBotProfile = {
                        id: targetBotProfile["data"]["id"],
                        profileObj: {
                            ...targetBotProfile["data"],
                            personalityObj: BotHelper.paresYmlString(targetBotProfile["data"].personality) ?? {},
                            responseStyleObj: BotHelper.paresYmlString(targetBotProfile["data"].responseStyle) ?? {},
                            backgroundObj: BotHelper.paresYmlString(targetBotProfile["data"].background) ?? {},
                            storyObj: BotHelper.paresYmlString(targetBotProfile["data"].story) ?? {},
                            symptomsAndBehavioursObj: BotHelper.paresYmlString(targetBotProfile["data"].symptomsAndBehaviours) ?? {}                    }
                    }
                    loadProfile(formattedTargetBotProfile)
                    history.push("/profilesetup/user-profile")
                }

            }
        }   
    }

    handleChangeIndex = index => {
        this.setState({
            index,
        })
    }

    redirectToBot = async (path = "chatroom/pdfbot") => {
        const { history, config, user, login, updateAcceptTerms } = this.props
        const userId = uuidv4()
        const questionSessionId = uuidv4()
        await login({
            id: userId,
            sessionId: questionSessionId
        })
        await history.push(path)
    }

    render() {
        const { index, modalOpen } = this.state
        // console.log("props", this.props)
        const { history, config, user, login, updateAcceptTerms } = this.props
        const { dict, bot, acceptTerms } = config
        const lang = dict['welcome'][bot]
        // console.log("language", lang)

        return (<CustomTheme>
            <Router>
                <Stack
                    direction={"column"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    sx={{
                        bgcolor: index === 0 ? 'background.gray' : 'background.highlight',
                        flexGrow: 1,
                        flexDirection: 'column',
                        p: 0,
                        pt: {
                            xs: 2,
                            sm: 6,
                            md: 8
                        },
                        pb: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        },
                        overflow: 'auto',
                    }}
                >

                    {/*<Grid container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        // spacing={3}
                        // columnSpacing={3}
                        sx={{
                            // bgcolor: index === 0 ? 'background.gray':'background.highlight',
                            pb: 7,
                            ml: "auto",
                            mr: "auto",
                            maxWidth: 600
                        }}
                    >*/}
                    {/*<Grid item
                            sx={{
                                p: 0,
                                m: 0,
                                pt: {
                                    xs: 2,
                                    sm: 4,
                                    md: 8
                                }
                            }}
                        >
                            <SwitchButtons
                                index={index}
                                changeIndex={this.handleChangeIndex}
                            />
                        </Grid>*/}
                    <Grid item
                        xs={8}
                        sm={6}
                        md={6}
                        lg={6}
                        sx={{
                            // flex: 1,
                            m: 'auto',
                            p: 0,
                            // bgcolor: 'background.highlight',
                            // height: 200,
                            // width: 1
                        }}
                    >
                        <NurseOnboarding
                            headerText={lang["name"]}
                            descriptionText={lang["greetings"]}
                            call2ActionText={lang["c2aButton"]}
                            dict={lang}
                            onClick={async (userId, password) => {
                                this.setState({
                                    userId, password
                                })
                                if (!acceptTerms) {
                                    this.handelModalOpenClose(true)
                                    return
                                }
                                this.handleUserLogin(userId, password)
                                // console.log("passed userId ", userId)

                                // in this section, we only allow 1 chatbot per user

                                // this.redirectToBot("chatroom/pdfbot")
                                /*
                                const userId = uuidv4()
                                const questionSessionId = uuidv4()
                                await login({
                                    id: userId,
                                    sessionId: questionSessionId
                                })
                                await history.push("chatroom/pdfbot")
                                */
                            }}
                        />
                        {/*<FAQBotOnboarding
                                headerText={lang['name']}
                                descriptionText={lang['Greetings, my name is FAQ Bot. I am happy to answer all of your questions.']}
                                call2ActionText={lang['c2aButton']}
                                onClick={async () => {
                                    const userId = uuidv4()
                                    const questionSessionId = uuidv4()
                                    await login({
                                        id: userId,
                                        sessionId: questionSessionId
                                    })
                                    await history.push("chatroom/faqbot")
                                }}
                            />*/}
                        {/*<NurseOnboarding 
                                headerText={lang['How did we do?']}
                                descriptionText={lang['Chat with Anketo Bot to share your thoughts and concerns about the visit.']}
                                call2ActionText={lang['調査']}
                                onClick={async () => {
                                    const userId = uuidv4()
                                    const questionSessionId = uuidv4()
                                    await login({
                                        id: userId,
                                        sessionId: questionSessionId
                                    })
                                    await history.push("chatroom/faqbot")
                                }}
                            />*/}

                    </Grid>
                    <Modal
                        open={modalOpen}
                        onClose={() => this.handelModalOpenClose(false)}
                        aria-labelledby="parent-modal-title"
                        aria-describedby="parent-modal-description"
                    >
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: {
                                xs: 1,
                                sm: 400
                            },
                            bgcolor: 'background.paper',
                            border: '2px solid #000',
                            boxShadow: 24,
                            p: 4
                        }}>
                            <Texts.Tip>{lang['disclaimer']}</Texts.Tip>
                            <Stack
                                direction="row"
                                justifyContent={"space-between"}
                            >

                                <Buttons.OutlinedButton onClick={() => {
                                    // updateAcceptTerms(true)
                                    this.handelModalOpenClose(false)
                                }}>{lang['cancel']}</Buttons.OutlinedButton>
                                <Buttons.OutlinedButton
                                    sx={{
                                        bgcolor: 'primary.dark'
                                    }}
                                    onClick={async () => {
                                        await updateAcceptTerms(true)
                                        await this.handelModalOpenClose(false)
                                        await this.handleUserLogin(this.state.userId, this.state.password)
                                        // await this.redirectToBot("profilesetup")
                                    }}>
                                    <Texts.Paragraph
                                        sx={{
                                            color: 'white'
                                        }}
                                    >{lang["accept"]}</Texts.Paragraph>
                                </Buttons.OutlinedButton>
                            </Stack>

                        </Box>
                    </Modal>
                    {/*<Grid item
                            xs={8}
                            sm={6}
                            md={6}
                            lg={6}
                            sx={{
                                m: 'auto',
                                p: 2,
                            }}
                        >

                        </Grid>*/}
                    {/*</Grid>*/}
                </Stack>


            </Router>
        </CustomTheme>)
    }
}
/**
usage example
    {<SwipeableWrapper
        index={index}
        onChangeIndex={this.handleChangeIndex}
        enterFAQBotRoom={async () => {

            this.redirectToBot("chatroom/faqbot")
        }}
        enterNurseRoom={async () => {

        }}
    />}
 */
const SwipeableWrapper = ({
    index,
    onChangeIndex,
    enterNurseRoom,
    enterFAQBotRoom
}) => {
    return (<SwipeableViews index={index} onChangeIndex={onChangeIndex}>
        <NurseOnboarding
            headerText={"Wonderer V1"}
            descriptionText={"I am the Mental Health Bot designed to train you to talk to people with different mental health conditions."}
            call2ActionText={"Start"}
            onClick={enterNurseRoom}
        />
        <FAQBotOnboarding
            headerText={"心房細動情報ボット"}
            descriptionText={"こんにちは。心房細動情報ボットと申します。あなたの質問にお答えします。"}
            call2ActionText={"スタート"}
            onClick={enterFAQBotRoom}
        />
    </SwipeableViews>)
}


let OnboardingContainer = props => {
    const { dispatch, user, config, botProfile } = props


    const boundActionCreators = useMemo(() => bindActionCreators({
        ...UserActions,
        ...ConfigActions,
        ...BotProfileActions,
        resetSession: methods.RESET_SESSION
    }, dispatch), [dispatch])

    return <Onboarding user={user} config={config} botProfile={botProfile} {...boundActionCreators} {...props} />
}

OnboardingContainer = connect(state => ({ user: state.user, config: state.config }))(OnboardingContainer)

export default withRouter(OnboardingContainer)